import tw from 'twin.macro'
import React, { Fragment, useRef } from 'react'
import { CgChevronDown } from 'react-icons/cg'

import { Combobox } from '@headlessui/react'
import * as Portal from '@radix-ui/react-portal'

import { usePopper } from 'common/hooks/usePopper'
import { SuggestionContainer, SuggestionItem } from 'common/components/Suggestions/Suggestions'
import { inputBase } from 'common/components/Input/Input'
import './numInputStyles.css'

export const estimateMethods = {
  perRep: 'perRep',
  perSet: 'perSet',
}

export const availableEstimateValues = [
  {
    value: estimateMethods.perRep,
    displayValue: 'Time per rep',
  },
  { value: estimateMethods.perSet, displayValue: 'Total time' },
]

export default function EstMethodSelect({ inputRef, name, value, setValue }) {
  const comboboxBtnRef = useRef()

  const handleInputKeyDown = (e) => {
    const acceptedCodes = ['Enter', 'Tab', 'ArrowUp', 'ArrowDown']
    if (!acceptedCodes.includes(e.code)) {
      e.preventDefault()
    } else if (e.code === 'Enter' && !e.shiftKey) {
      comboboxBtnRef.current.click()
    }
  }

  let [popperTrigger, popperContainer] = usePopper({
    placement: 'bottom-start',
    strategy: 'fixed',
  })

  const inputWidth = inputRef?.current?.getBoundingClientRect()?.width || 144
  return (
    <Combobox value={value} onChange={(newValue) => setValue(newValue)}>
      <div ref={popperTrigger}>
        <Combobox.Button ref={comboboxBtnRef} as='div' className='relative inline-flex'>
          <Combobox.Input
            ref={(e) => {
              inputRef.current = e
            }}
            name={name}
            placeholder='Select estimate method'
            autoComplete='off'
            displayValue={(value) =>
              availableEstimateValues.find((estimate) => estimate.value === value)?.displayValue ||
              'Select estimate method'
            }
            onKeyDown={handleInputKeyDown}
            className='text-ellipsis bg-inherit cursor-pointer'
            css={[inputBase, tw`caret-transparent w-36 h-auto px-2 py-2 rounded-md text-sm`]}
          />
          <CgChevronDown className='absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500 w-4 h-4' />
        </Combobox.Button>
      </div>
      <Portal.Root>
        <Combobox.Options className='z-[999]' ref={popperContainer} modal={false}>
          <SuggestionContainer containerStyle={{ width: inputWidth }}>
            {availableEstimateValues.map((estimate) => (
              <Combobox.Option as={Fragment} key={estimate.value} value={estimate.value}>
                {({ selected, active }) => (
                  <SuggestionItem active={active}>
                    <div className='flex items-center text-sm'>{estimate.displayValue}</div>
                  </SuggestionItem>
                )}
              </Combobox.Option>
            ))}
          </SuggestionContainer>
        </Combobox.Options>
      </Portal.Root>
    </Combobox>
  )
}
